function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.7358 0.272976C11.3807 -0.0821075 10.8071 -0.0821075 10.452 0.272976L5.99983 4.71607L1.54763 0.263871C1.19255 -0.0912123 0.618955 -0.0912123 0.263871 0.263871C-0.0912123 0.618955 -0.0912123 1.19255 0.263871 1.54763L4.71607 5.99983L0.263871 10.452C-0.0912123 10.8071 -0.0912123 11.3807 0.263871 11.7358C0.618955 12.0909 1.19255 12.0909 1.54763 11.7358L5.99983 7.2836L10.452 11.7358C10.8071 12.0909 11.3807 12.0909 11.7358 11.7358C12.0909 11.3807 12.0909 10.8071 11.7358 10.452L7.2836 5.99983L11.7358 1.54763C12.0818 1.20166 12.0818 0.618955 11.7358 0.272976Z",
  fill: "white"
});

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconClose.6309009a.svg";
export { ForwardRef as ReactComponent };